export function toUtcMidnight(date: Date | null): Date | null {
   if (!date) return null;
   return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
}
